import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './loyalty-progress.magic.css.js';
import LoyaltyProgressComponent from './loyalty-progress.js';

const __vue_script__ = LoyaltyProgressComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "loyalty-progress",
      class: {
        "loyalty-progress--top-nav": _vm.topNavVariant,
        "loyalty-progress--top-nav-large": _vm.topNavVariant && _vm.isLarge
      },
      attrs: {
        part: _vm.$p("loyalty-progress", {
          "loyalty-progress--top-nav": _vm.topNavVariant
        }),
        "data-v-test-id": "loyalty-progress"
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "wrapper",
          class: { "loyalty-program--wrapper": _vm.wrapperWidth },
          attrs: { part: "wrapper" }
        },
        [
          !_vm.showProgressBarOnly && _vm.topNavVariant
            ? _c(
                "div",
                {
                  staticClass: "summary",
                  class: { "summary--top-nav": _vm.topNavVariant },
                  attrs: {
                    part: _vm.$p("summary", {
                      "summary--top-nav": _vm.topNavVariant
                    })
                  }
                },
                [
                  !_vm.isLarge
                    ? _c("magic-ui-text", {
                        staticClass: "text",
                        class: { "text--top-nav": _vm.topNavVariant },
                        attrs: {
                          part: _vm.$p("text", {
                            "text--top-nav": _vm.topNavVariant
                          }),
                          content: "Progress"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shouldShowInfo && !_vm.showProgressBarOnly
                    ? _c("magic-ui-icon", {
                        staticClass: "icon icon--top-nav",
                        attrs: {
                          name: "info",
                          part: "icon",
                          "data-v-test-id": "loyalty-progress-icon"
                        },
                        on: {
                          click: function($event) {
                            return _vm.infoClick()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "progress-bar-wrapper" },
            [
              _vm.topNavVariant && _vm.isComplete
                ? _c(
                    "button",
                    {
                      staticClass: "progress-bar-reward-button",
                      attrs: { type: "button" },
                      on: { click: _vm.goToRewards }
                    },
                    [
                      _c("magic-ui-icon", {
                        staticClass: "progress-bar-reward-icon",
                        attrs: { name: "progress-bar-reward" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("magic-ui-progress-bar", {
                staticClass: "progress-bar",
                class: _vm.topNavVariant ? "progress-bar--top-nav-enabled" : "",
                attrs: {
                  part: "progress-bar",
                  "data-v-test-id": "loyalty-progress-bar",
                  progress: _vm.roundedProgress,
                  "is-top-navigation-enabled": _vm.topNavVariant
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.showProgressBarOnly || _vm.showLevelOnTop
            ? _c(
                "div",
                { staticClass: "summary", attrs: { part: "summary" } },
                [
                  _c("magic-ui-text", {
                    staticClass: "text",
                    class: {
                      "level-top": _vm.showLevelOnTop,
                      "text--top-nav-small": _vm.topNavVariant
                    },
                    attrs: {
                      part: "text",
                      "data-v-test-id": "loyalty-progress-level",
                      content: _vm.$t(_vm.levelTranslation, {
                        level: _vm.userLevel
                      })
                    }
                  }),
                  _vm._v(" "),
                  !_vm.showProgressBarOnly
                    ? _c("magic-ui-text", {
                        staticClass: "text",
                        class: { "text--top-nav-small": _vm.topNavVariant },
                        attrs: {
                          part: "text",
                          "data-v-test-id": "loyalty-progress-text",
                          content: _vm.$t("progress-bar.progress-text", {
                            progress: _vm.roundedProgress
                          })
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.shouldShowInfo &&
                  !_vm.showProgressBarOnly &&
                  !_vm.topNavVariant
                    ? _c("magic-ui-icon", {
                        staticClass: "icon",
                        attrs: {
                          name: "info",
                          part: "icon",
                          "data-v-test-id": "loyalty-progress-icon"
                        },
                        on: {
                          click: function($event) {
                            return _vm.infoClick()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade-in" } },
        [
          _vm.isComplete &&
          _vm.showRewardsButton &&
          _vm.displayRewardsButton &&
          !_vm.topNavVariant
            ? _c("magic-ui-button", {
                staticClass: "button",
                attrs: {
                  wide: "",
                  "no-margin": "",
                  variant: "primary",
                  part: "button",
                  "data-v-test-id": "loyalty-progress-reward-button"
                },
                domProps: { innerHTML: _vm._s(_vm.$t("progress-bar.button")) },
                on: { click: _vm.goToRewards }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-f916e4ca_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-f916e4ca";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
